import UAParser from "ua-parser-js";

const MOBILE = "mobile";
const TABLET = "tablet";

const UA = new UAParser();

const device = UA.getDevice();

const getNavigatorInstance = () => {
    if (typeof window !== "undefined") {
        if (window.navigator || navigator) {
            return window.navigator || navigator;
        }
    }

    return false;
};

const isIOS13IPad = () => {
    const nav = getNavigatorInstance();

    return (
        nav && nav.platform
            && (nav.platform.indexOf("iPad") !== -1 || (nav.platform === "MacIntel" && nav.maxTouchPoints > 1 && !window.MSStream))
    );
};

const isMobileOnly = device.type === MOBILE;
const isTablet = (device.type === TABLET) || isIOS13IPad();

export { isMobileOnly, isTablet };
